import React, { useState, useEffect } from "react";
import { onAuthStateChanged, getAuth } from "firebase/auth";
import { db } from "../config";
import { doc, updateDoc } from "firebase/firestore";
import axios from "axios";
import { Helmet } from "react-helmet";
import Header from "../Components/Header";
import Nav from "../Components/Nav";

function Kyc() {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    fullName: "",
    dob: "",
    address: "",
    country: "",
    idType: "",
    idNumber: "",
    expiryDate: "",
    idFront: null,
    idBack: null,
    selfie: null,
  });

  const [user, setUser] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser || null);
    });
    return () => unsubscribe();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setForm({ ...form, [name]: files ? files[0] : value });
  };

  const nextStep = () => setStep((prev) => prev + 1);
  const prevStep = () => setStep((prev) => prev - 1);

  const uploadToCloudinary = async (file) => {
    if (!file) return null;
    const cloudName = "draaumst7"; // Replace with your Cloudinary cloud name
    const uploadPreset = "kh2yomwe"; // Replace with your Cloudinary upload preset
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", uploadPreset); // Replace with your preset
    formData.append("folder", "kyc_uploads");

    const cloudinaryUrl = `https://api.cloudinary.com/v1_1/${cloudName}/auto/upload`; // Replace "your_cloud_name"

    const response = await axios.post(cloudinaryUrl, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data.secure_url;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) return alert("User not authenticated.");
    setUploading(true);

    try {
      const idFrontURL = await uploadToCloudinary(form.idFront);
      const idBackURL = await uploadToCloudinary(form.idBack);
      const selfieURL = await uploadToCloudinary(form.selfie);

      console.log("Uploaded URLs:", {
        idFrontURL, 
        idBackURL,
        selfieURL,
      });

      const userRef = doc(db, "users", user.uid);
      await updateDoc(userRef, {
       kyc: {
    fullName: form.fullName,
    dob: form.dob,
    address: form.address,
    country: form.country,
    idType: form.idType,
    idNumber: form.idNumber,
    expiryDate: form.expiryDate,
    idFrontURL,
    idBackURL,
    selfieURL,
    status: "pending",
  },
      });

      setMessage("KYC submitted successfully. Status: pending.");
      setForm({
        fullName: "",
        dob: "",
        address: "",
        country: "",
        idType: "",
        idNumber: "",
        expiryDate: "",
        idFront: null,
        idBack: null,
        selfie: null,
      });
      setStep(1);
    } catch (err) {
      console.error("KYC error:", err);
      setMessage("An error occurred during submission.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
<div className="container mt-5">
  <div className="d-flex justify-content-center">
    <div className="card shadow p-4" style={{ width: "100%", maxWidth: "650px" }}>
      <h3 className="text-center mb-4">Complete Your KYC</h3>
      <form onSubmit={handleSubmit}>
        {step === 1 && (
          <>
            <h5 className="mb-3 text-center">Step 1: Personal Information</h5>
            <div className="mb-3">
              <label className="form-label">Full Name</label>
              <input type="text" name="fullName" className="form-control" required value={form.fullName} onChange={handleChange} />
            </div>
            <div className="mb-3">
              <label className="form-label">Date of Birth</label>
              <input type="date" name="dob" className="form-control" required value={form.dob} onChange={handleChange} />
            </div>
            <div className="mb-3">
              <label className="form-label">Address</label>
              <input type="text" name="address" className="form-control" required value={form.address} onChange={handleChange} />
            </div>
            <div className="mb-3">
              <label className="form-label">Country</label>
              <input type="text" name="country" className="form-control" required value={form.country} onChange={handleChange} />
            </div>
          </>
        )}

        {step === 2 && (
          <>
            <h5 className="mb-3 text-center">Step 2: ID Details</h5>
            <div className="mb-3">
              <label className="form-label">ID Type</label>
              <select name="idType" className="form-control" required value={form.idType} onChange={handleChange}>
                <option value="">Select</option>
                <option value="Driver's License">Driver's License</option>
                <option value="National ID">National ID</option>
                <option value="Passport">Passport</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">ID Number</label>
              <input type="text" name="idNumber" className="form-control" required value={form.idNumber} onChange={handleChange} />
            </div>
            <div className="mb-3">
              <label className="form-label">Expiry Date</label>
              <input type="date" name="expiryDate" className="form-control" required value={form.expiryDate} onChange={handleChange} />
            </div>
          </>
        )}

        {step === 3 && (
          <>
            <h5 className="mb-3 text-center">Step 3: Upload Documents</h5>
            <div className="mb-3">
              <label className="form-label">ID Front Image</label>
              <input type="file" name="idFront" accept="image/*,application/pdf" className="form-control" required onChange={handleChange} />
            </div>
            <div className="mb-3">
              <label className="form-label">ID Back Image</label>
              <input type="file" name="idBack" accept="image/*,application/pdf" className="form-control" required onChange={handleChange} />
            </div>
            <div className="mb-3">
              <label className="form-label">Selfie</label>
              <input type="file" name="selfie" accept="image/*" className="form-control" required onChange={handleChange} />
            </div>
          </>
        )}

        <div className="d-flex justify-content-between mt-4">
          {step > 1 && (
            <button type="button" className="btn btn-outline-secondary" onClick={prevStep}>
              Back
            </button>
          )}
          {step < 3 ? (
            <button type="button" className="btn btn-primary ms-auto" onClick={nextStep}>
              Next
            </button>
          ) : (
            <button type="submit" className="btn btn-success ms-auto" disabled={uploading}>
              {uploading ? "Submitting..." : "Submit KYC"}
            </button>
          )}
        </div>
      </form>

      {message && <div className="alert alert-info text-center mt-4">{message}</div>}
    </div>
  </div>
</div>

    </>
  );
}

export default Kyc;
